import XLSX from 'sheetjs-style';
import FileSaver from 'file-saver';
import { Button } from '@appkit4/react-components';
import useLocale from '../locale/useLocale';
import { FC } from 'react';
import { OptimisedCoachee } from '../api/generated/models';
import { IndexedCoachData } from '../models/indexedCoachData';
import useToast from '../helpers/useToast';
import { ImportDataTypeEnum } from '../models/importDataTypeEnum';

interface ExportAllocationResultsProps {
    optimisedCoacheeData: OptimisedCoachee[];
    optimisedCoachData: IndexedCoachData[];
    fileName: string;
    importDataType: number;
}

const ExportAllocationResults: FC<ExportAllocationResultsProps> = ({
    optimisedCoacheeData,
    optimisedCoachData,
    fileName,
    importDataType,
}) => {
    const { l } = useLocale();
    const showToast = useToast();

    const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

    const fileExtension = '.xlsx';

    const exportToExcel = async () => {
        const coacheeHeaders = [
            'Coachee ID',
            'Coachee',
            'Coachee Grade',
            'Career Coach',
            'Career Coach ID',
            'Relationship Leader',
            'Coachee Email',
        ];

        const coachHeaders = [
            'Coach',
            'Coach ID',
            'Coach Grade',
            'Employment',
            'Coach Email',
        ];

        let coacheeData: (string | null | undefined)[][] = [];
        let coachData: (string | null | undefined)[][] = [];

        if (importDataType == ImportDataTypeEnum.Capability) {
            coacheeHeaders.splice(
                3,
                0,
                'Coachee Capability',
                'Coachee Supervisory Org'
            );

            coachHeaders.splice(
                3,
                0,
                'Coach Capability',
                'Coach Supervisory Org'
            );

            coacheeData = optimisedCoacheeData.map((coachee) => [
                coachee.id,
                coachee.name,
                coachee.grade,
                coachee.capability,
                coachee.supervisoryOrg,
                coachee.careerCoach?.name,
                coachee.careerCoach?.id,
                coachee.relationshipLeader,
                coachee.email,
            ]);

            coachData = optimisedCoachData.map((coach) => [
                coach.name,
                coach.id,
                coach.grade,
                coach.capability,
                coach.supervisoryOrg,
                coach.employmentType,
                coach.email,
            ]);
        } else {
            coacheeHeaders.splice(3, 0, 'Coachee Cost Center');
            coachHeaders.splice(3, 0, 'Coach Cost Center');

            coacheeData = optimisedCoacheeData.map((coachee) => [
                coachee.id,
                coachee.name,
                coachee.grade,
                coachee.costCenter,
                coachee.careerCoach?.name,
                coachee.careerCoach?.id,
                coachee.relationshipLeader,
                coachee.email,
            ]);

            coachData = optimisedCoachData.map((coach) => [
                coach.name,
                coach.id,
                coach.grade,
                coach.costCenter,
                coach.employmentType,
                coach.email,
            ]);
        }

        const ws = XLSX.utils.aoa_to_sheet([coacheeHeaders, ...coacheeData]);
        const ws2 = XLSX.utils.aoa_to_sheet([coachHeaders, ...coachData]);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Coachees');
        XLSX.utils.book_append_sheet(wb, ws2, 'Coaches');

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);

        showToast(
            'Success',
            'Allocation result download initiated.',
            'success'
        );
    };

    return (
        <>
            <Button
                className="postallocation-button-component"
                style={{
                    position: 'relative',
                    float: 'left',
                    marginRight: '1rem',
                }}
                kind="secondary"
                icon="icon-share-outline"
                disabled={optimisedCoacheeData.length == 0}
                onClick={exportToExcel}
            >
                {l('_export')}
            </Button>
        </>
    );
};

export default ExportAllocationResults;
